<div class="content-area">
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading && post">
    <div class="clr-col-12 clr-col-md-8 post-wrapper">
      <div class="featured-image-wrapper" [style.backgroundImage]="postImage"></div>
      <h1 class="text-center" [innerHTML]="post.title.rendered"></h1>
      <div class="text-center">
        <span class="tag mr-1 py-1 px-2" *ngFor="let category of post.excerptTags">{{category}}</span>
      </div>
      <div class="post-content">
        <h3>{{itemImages.length}} imagini în această colecție</h3>

        <div [innerHTML]="sanitizedContent" class="post-content"></div>

        <div class="clr-row">
          <div class="card clr-col-12 clr-col-md-3" *ngFor="let item of itemImages; let index = index">
            <div class="card-header">
              Imaginea {{index + 1}}
            </div>
            <div class="card-block">
              <div class="card-text" [id]="'image'+index">
                <img [src]="item.large" [alt]="'imagine de colorat cu '+post.title.rendered"/>
              </div>
            </div>
            <div class="card-footer">
              <button class="orange-outline-button small" [printSectionId]="'image'+index" ngxPrint>Imprimă</button>
              <a [href]="item.large" [download]="'Fun Bible - Plansa de colorat cu '+post.title.rendered" class="orange-outline-button small">Descarca</a>
            </div>
          </div>
        </div>
      </div>

      <div class="disqus-wrapper">
        <disqus [identifier]="post.title.rendered"></disqus>
      </div>
    </div>
  </div>
</div>